//#region src/dlq-message.ts
/**
* Type guard: narrows an unknown JSON value to a `DlqMessage`. Used by the
* admin API to defensively validate envelopes pulled from the stream.
*/
function isDlqMessage(value) {
	if (value === null || typeof value !== "object") return false;
	const v = value;
	if (typeof v["originalSubject"] !== "string" || typeof v["failedAt"] !== "string" || typeof v["attempts"] !== "number" || typeof v["lastError"] !== "string") return false;
	if (typeof v["orgId"] !== "string" || v["orgId"].length === 0) return false;
	if (!("originalPayload" in v)) return false;
	const sm = v["streamMetadata"];
	if (sm === null || typeof sm !== "object") return false;
	const m = sm;
	return typeof m["stream"] === "string" && typeof m["consumer"] === "string" && typeof m["streamSequence"] === "number" && typeof m["consumerSequence"] === "number" && typeof m["timestamp"] === "string";
}
/**
* The well-known JetStream stream name used for DLQ envelopes across the
* platform. Mirrors the Python SDK constant.
*/
const ZION_DLQ_STREAM = "ZION_DLQ";
/**
* The DLQ subject-namespace prefix (trailing dot required). Module-PRIVATE —
* the single grammar source for `ZION_DLQ_SUBJECT_FILTER`, `dlqSubjectFor`,
* and `appDlqPublishSubject`, so the grant and the write path can never drift.
*/
const DLQ_SUBJECT_PREFIX = "zion.dlq.";
/**
* The wildcard subject filter the DLQ stream binds to.
* `zion.dlq.>` matches every per-original-subject DLQ topic.
*/
const ZION_DLQ_SUBJECT_FILTER = `${DLQ_SUBJECT_PREFIX}>`;
/**
* Compose the DLQ subject for a given original subject.
*
* Pure function — no side effects, no validation beyond shape.
*/
function dlqSubjectFor(originalSubject) {
	return `${DLQ_SUBJECT_PREFIX}${originalSubject}`;
}
/**
* The bounded DLQ PUBLISH grant for an app principal (nats-app-jetstream-
* consumption AD-2): `zion.dlq.zion.<appScope>.>`. `dlqSubjectFor(subject)`
* prefixes the ORIGINAL subject, and an app's own subjects all live under
* `zion.<appScope>.>` — so this wildcard covers exactly the app's own
* failure-path DLQ writes and nothing else. Exact-match admitted by core-api's
* mint gate; composed into the operator's mint request. Same no-literals rule
* as `appJetStreamGrantSubjects`.
*/
function appDlqPublishSubject(appScope) {
	return `${DLQ_SUBJECT_PREFIX}zion.${appScope}.>`;
}
//#endregion
export { ZION_DLQ_STREAM, ZION_DLQ_SUBJECT_FILTER, appDlqPublishSubject, dlqSubjectFor, isDlqMessage };

//# sourceMappingURL=dlq-message.js.map